import { Cross } from "@styled-icons/entypo";
import styled from "styled-components";

import { colors } from "../../../constants/colors";

export const StyledLayout = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;

  display: flex;
  flex-direction: column;

  width: 100vw;
  height: 100vh;

  background: rgba(170, 170, 170, 0.8);
`;

export const StyledCloseButton = styled(Cross)`
  color: ${colors.white};

  position: relative;
  top: -3rem;
  left: calc(100% - 3rem);

  width: 3rem;
  height: 3rem;
`;

export type StyledModalProps = {
  width?: string;
  height?: string;
  overflow?: "auto" | "hidden";
};

export const StyledCard = styled.div<StyledModalProps>`
  margin: auto;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  box-sizing: border-box;
`;

export const StyledContent = styled.div<StyledModalProps>`
  box-sizing: border-box;
  padding: 0 3rem 3rem;
  width: 100%;
  height: calc(100% - 3rem);
  min-height: min-content;
  overflow: ${({ overflow }) => overflow};
`;
